import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'password'>,
  Pick<ReqCreateOrUpdateChallenge, 'password'>
> = ({ password }) => {
  return { password };
};

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'password'>,
  Pick<ChallengeFormType, 'password'>
> = ({ password }) => ({ password });
